import {Button, Form, Input, message, Modal, Space, Tooltip, Typography} from "antd";
import {LockOutlined, UserOutlined} from "@ant-design/icons";
import '../login/useToken';
import '../../style/css/login.css';
import {useTranslation} from "react-i18next";
import DB_Auth, {postAuthLogin} from "../../database/auth/auth";
import md5 from "md5";
import ModalWindow from "../modal";
import logo_white from '../../style/images/logo_whiite.png'
import React, {useEffect, useState} from "react";


export default function LoginPage(props) {
    const {t, i18n} = useTranslation();
    const [display, setDisplay] = useState(props.display)

    const {sendForgotPassword} = DB_Auth('')
    const {errorConnect} = ModalWindow();
    // const [lang, setLang] = useState('uk_UA')
    const [forgotPassword, setForgotPassword] = useState(false)
    const [form1] = Form.useForm();

    useEffect(() => {
        if (!props.display) {
            setDisplay(false)
        } else {
            setDisplay(true)
        }
    }, [props.display])

    // useEffect(() => {
    //     i18n.changeLanguage(lang)
    // }, [lang])

    const handleOk = async () => {
        if (form1.getFieldValue('email').length > 0) {
            const data = new FormData()
            data.append('email', form1.getFieldValue('email'))


            if (await sendForgotPassword(data)) {
                setForgotPassword(false);
            } else {
                errorConnect();
            }
        }
    };

    const cancel = () => {
        setForgotPassword(false)
    }

    const ForgotPassword = () => {
        return (
            <Modal title={t('title_forgot_password')} onOk={handleOk} onCancel={cancel} visible={forgotPassword} cancelText={t('cancel_forgot')}>
                <Form
                    form={form1}
                    autoComplete="off">

                    <Form.Item
                        name="email"
                        label={t('email')}
                        rules={[
                            {
                                required: true,
                                message: t('e_input', {input: t('email').toLowerCase()}),
                            },
                            {
                                type: "email",
                                message: t('e_valid_email'),
                            }
                        ]}
                        hasFeedback
                    >
                        <Input/>
                    </Form.Item>
                </Form>
            </Modal>
        )
    }

    const onFinish = (values) => {
        const formData = new FormData;
        formData.append('email', values['email']);
        formData.append('password', md5(values['password']));

        postAuthLogin(formData)
            .then(res => {
                if (res.status === 200) {
                    props.setToken(res.data.token);

                } else {
                    message.error(t('error_login_or_password'));
                    console.log("Error login or password")
                }
            })
            .catch(() => {
                errorConnect();
            });
    };

    if (display) {
        return (
            <>
                {/*<div style={{position: 'absolute', padding: '20pt', width: '100%'}}>*/}
                {/*    <Segmented*/}
                {/*        size="small"*/}
                {/*        onChange={setLang}*/}
                {/*        value={lang}*/}
                {/*        style={{float: 'right'}}*/}
                {/*        options={[*/}
                {/*            {*/}
                {/*                label: '🇺🇸',*/}
                {/*                value: 'en_US',*/}
                {/*            },*/}
                {/*            {*/}
                {/*                label: '🇺🇦',*/}
                {/*                value: 'uk_UA',*/}

                {/*            },*/}
                {/*            {*/}
                {/*                label: '🇷🇺',*/}
                {/*                value: 'ru_RU',*/}

                {/*            },*/}
                {/*        ]}/>*/}
                {/*</div>*/}
                <div style={{background: "linear-gradient(135deg, #F6CFBE 0%, #B9DCF2 100%)", height: '100%'}}>
                    <div style={{
                        position: 'absolute',
                        margin: '20pt 0 0 20pt',
                        width: '70pt',
                        height: '70pt',
                        backgroundImage: `url(${logo_white})`,
                        backgroundSize: '70pt',
                        backgroundRepeat: 'no-repeat'
                    }}/>

                    <Space direction={'vertical'}
                           style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%',}}>
                        <Tooltip title={t('promp_text')}>
                            <Typography.Title copyable={false} style={{color: '#FFF'}}>{t('log_in')} </Typography.Title>
                        </Tooltip>
                        <Space>

                            <Form
                                name="normal_login"
                                className="login-form"
                                initialValues={{
                                    remember: true,
                                }}
                                onFinish={onFinish}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        this.submit()
                                    }
                                }}
                            >
                                <Form.Item
                                    name="email"
                                    rules={[
                                        {
                                            type: 'email',
                                            message: t('e_valid_email'),
                                        },
                                        {
                                            required: true,
                                            message: t('e_input', {input: t('email').toLowerCase()}),
                                        },
                                    ]}
                                >
                                    <Input
                                        type="email"
                                        prefix={<UserOutlined className="site-form-item-icon"/>}
                                        placeholder={t('email')}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="password"
                                    rules={[
                                        {
                                            required: true,
                                            message: t('e_input', {input: t('password').toLowerCase()}),
                                        },
                                    ]}
                                >
                                    <Input
                                        type="password"
                                        prefix={<LockOutlined className="site-form-item-icon"/>}
                                        placeholder={t('password')}
                                    />
                                </Form.Item>
                                <Form.Item>
                                    <Button type={'link'} className="login-form-forgot"
                                            onClick={e => setForgotPassword(true)}>
                                        {t('forgot_password')}
                                    </Button>
                                </Form.Item>

                                <Form.Item>
                                    <Button type="primary" size={'large'} htmlType="submit"
                                            className="login-form-button">
                                        {t('log_in')}
                                    </Button>
                                    {/*Or <a href="">register now!</a>*/}
                                </Form.Item>
                            </Form>
                        </Space>
                    </Space>
                </div>

                <ForgotPassword/>
            </>
        );
    }
};
